<template>
  <div class="OdontogramaDetalle">
    <v-dialog
      width="800"
      v-model="showDialogDetalle"
      scrollable
    >
      <v-card>
        <v-card-title>Detalle del odontograma</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <h3 class="mb-3">Superior Izquierdo</h3>
              <div v-for="n in 8" :key="'si'+n" class="mt-4">
                <label><strong>Diente 1{{n}}</strong></label><br>
                <div>Anotaciones: {{odontograma['si'+n+'_odo']}}</div>
                <div v-if="odontograma['si'+n+'_cart_odo']">
                  <div class="mt-2">Servicios:</div>
                  <div v-for="(servicio, idx) in getServiciosDiente('si'+n)" :key="'si'+n+idx" class="service-item">
                    <v-text-field
                      v-model="servicio.cant_sca"
                      type="number"
                      min="1"
                      dense
                      hide-details
                      style="max-width: 60px; display: inline-block;"
                      @change="_updateServiceQuantityInDetail('si'+n, idx)"
                    />
                    <span class="ml-2">x {{servicio.desc_ser}}: {{$nF(servicio.cant_sca * servicio.precio_sca)}}</span>
                  </div>
                </div>
              </div>
              <v-divider class="my-4"/>
            </v-col>
            
            <v-col cols="12" sm="6" md="6">
              <h3 class="mb-3">Superior Derecho</h3>
              <div v-for="n in 8" :key="'sd'+n" class="mt-4">
                <label><strong>Diente 2{{n}}</strong></label><br>
                <div>Anotaciones: {{odontograma['sd'+n+'_odo']}}</div>
                <div v-if="odontograma['sd'+n+'_cart_odo']">
                  <div class="mt-2">Servicios:</div>
                  <div v-for="(servicio, idx) in getServiciosDiente('sd'+n)" :key="'sd'+n+idx" class="service-item">
                    <v-text-field
                      v-model="servicio.cant_sca"
                      type="number"
                      min="1"
                      dense
                      hide-details
                      style="max-width: 60px; display: inline-block;"
                      @change="_updateServiceQuantityInDetail('sd'+n, idx)"
                    />
                    <span class="ml-2">x {{servicio.desc_ser}}: {{$nF(servicio.cant_sca * servicio.precio_sca)}}</span>
                  </div>
                </div>
              </div>
              <v-divider class="my-4"/>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <h3 class="mb-3">Inferior Izquierdo</h3>
              <div v-for="n in 8" :key="'ii'+n" class="mt-4">
                <label><strong>Diente 4{{n}}</strong></label><br>
                <div>Anotaciones: {{odontograma['ii'+n+'_odo']}}</div>
                <div v-if="odontograma['ii'+n+'_cart_odo']">
                  <div class="mt-2">Servicios:</div>
                  <div v-for="(servicio, idx) in getServiciosDiente('ii'+n)" :key="'ii'+n+idx" class="service-item">
                    <v-text-field
                      v-model="servicio.cant_sca"
                      type="number"
                      min="1"
                      dense
                      hide-details
                      style="max-width: 60px; display: inline-block;"
                      @change="_updateServiceQuantityInDetail('ii'+n, idx)"
                    />
                    <span class="ml-2">x {{servicio.desc_ser}}: {{$nF(servicio.cant_sca * servicio.precio_sca)}}</span>
                  </div>
                </div>
              </div>
              <v-divider class="my-4"/>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <h3 class="mb-3">Inferior Derecho</h3>
              <div v-for="n in 8" :key="'id'+n" class="mt-4">
                <label><strong>Diente 3{{n}}</strong></label><br>
                <div>Anotaciones: {{odontograma['id'+n+'_odo']}}</div>
                <div v-if="odontograma['id'+n+'_cart_odo']">
                  <div class="mt-2">Servicios:</div>
                  <div v-for="(servicio, idx) in getServiciosDiente('id'+n)" :key="'id'+n+idx" class="service-item">
                    <v-text-field
                      v-model="servicio.cant_sca"
                      type="number"
                      min="1"
                      dense
                      hide-details
                      style="max-width: 60px; display: inline-block;"
                      @change="_updateServiceQuantityInDetail('id'+n, idx)"
                    />
                    <span class="ml-2">x {{servicio.desc_ser}}: {{$nF(servicio.cant_sca * servicio.precio_sca)}}</span>
                  </div>
                </div>
              </div>
              <v-divider class="my-4"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text v-text="'Cerrar'" @click="showDialogDetalle=false" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import forms from "@/mixins/forms.js";
export default {
  name: "OdontogramaDetalle",
  mixins: [forms],
  props: {
    value: String, //este es el id del odontograma a consultar
  },
  data() {
    return {
      odontograma: {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      },
      errors: {
        id: null,
      },
      showDialogDetalle: false,
      serviciosData: {}, // Para almacenar los servicios parseados de forma reactiva
    };
  },
  methods: {
    _getOdontograma() {
      if (this.value) {
        this._getThings("odontograma/" + this.value, "odontograma");
      }
    },
    _checkIfOdontogramaHasData() {
      if (this.odontograma.id) {
        this.showDialogDetalle = true;
      } else {
        this.$emit("input", null);
      }
    },
    getServiciosDiente(diente) {
      // Usar serviciosData si está disponible, sino parsear del odontograma
      if (this.serviciosData[diente]) {
        return this.serviciosData[diente];
      }
      
      try {
        if (this.odontograma[diente + '_cart_odo']) {
          const servicios = JSON.parse(this.odontograma[diente + '_cart_odo']);
          this.$set(this.serviciosData, diente, servicios);
          return servicios;
        }
      } catch (e) {
        console.error('Error parsing cart for', diente, e);
      }
      return [];
    },
    _updateServiceQuantityInDetail(diente, idx) {
      // Validar que la cantidad sea válida
      if (this.serviciosData[diente][idx].cant_sca < 1) {
        this.serviciosData[diente][idx].cant_sca = 1;
      }
      
      // Actualizar el odontograma con los nuevos datos
      this.$set(this.odontograma, diente + '_cart_odo', JSON.stringify(this.serviciosData[diente]));
      
      this.$emit("msg", "Cantidad actualizada");
    },
    _resetForm() {
      this.odontograma = {
        id_odo: null,
        id_pac_odo: null,
        id_usr_odo: null,
        fecha_odo: null,
      };
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this._getOdontograma();
      } else {
        this._resetForm();
      }
    },
    showDialogDetalle(newVal) {
      if (!newVal) {
        this.$emit("input", null);
        this._resetForm();
      }
    },
    odontograma: {
      deep: true,
      immediate: true,
      handler: "_checkIfOdontogramaHasData",
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 1rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.service-item {
  margin: 0.25rem 0;
  display: flex;
  align-items: center;
}
</style>